// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/health_and_wellness.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/health_and_wellness.proto.
 */
export const file_proto_model_core_place_types_health_and_wellness = /*@__PURE__*/
  fileDesc("CjZwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2hlYWx0aF9hbmRfd2VsbG5lc3MucHJvdG8SBmNhcm1lbiq8BgoaSGVhbHRoQW5kV2VsbG5lc3NQbGFjZVR5cGUSLgoqSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX1VOU1BFQ0lGSUVEEAASLworSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX0NISVJPUFJBQ1RPUhABEjAKLEhFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9ERU5UQUxfQ0xJTklDEAISKgomSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX0RFTlRJU1QQAxIpCiVIRUFMVEhfQU5EX1dFTExORVNTX1BMQUNFX1RZUEVfRE9DVE9SEAQSLAooSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX0RSVUdTVE9SRRAFEisKJ0hFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9IT1NQSVRBTBAGEioKJkhFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9NQVNTQUdFEAcSLgoqSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX01FRElDQUxfTEFCEAgSKwonSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX1BIQVJNQUNZEAkSMgouSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX1BIWVNJT1RIRVJBUElTVBAKEigKJEhFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9TQVVOQRALEjMKL0hFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9TS0lOX0NBUkVfQ0xJTklDEAwSJgoiSEVBTFRIX0FORF9XRUxMTkVTU19QTEFDRV9UWVBFX1NQQRANEjEKLUhFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9UQU5OSU5HX1NUVURJTxAOEjIKLkhFQUxUSF9BTkRfV0VMTE5FU1NfUExBQ0VfVFlQRV9XRUxMTkVTU19DRU5URVIQDxIuCipIRUFMVEhfQU5EX1dFTExORVNTX1BMQUNFX1RZUEVfWU9HQV9TVFVESU8QEEIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the enum carmen.HealthAndWellnessPlaceType.
 */
export const HealthAndWellnessPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_health_and_wellness, 0);

/**
 * Health and wellness place types
 *
 * @generated from enum carmen.HealthAndWellnessPlaceType
 */
export const HealthAndWellnessPlaceType = /*@__PURE__*/
  tsEnum(HealthAndWellnessPlaceTypeSchema);

